import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import { useEffect, useRef, useCallback, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, Scroll, Wrapper } from '../../utilities/Shared';
import { colorchange } from '../../utilities/Convertions';

const GL540 = ({ machine, events, updateEvent, list, updateList, fetchEvents }) => {
  const listItemsRef = useRef([]);
  const calendarRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [sortOption, setSortOption] = useState('job');
  const [sortedList, setSortedList] = useState([]);
  const [overTimeEarly, setOverTimeEarly] = useState(true);
  const [overTimeLate, setOverTimeLate] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [newFormData, setNewFormData] = useState({
    start: '',
    end: '',
    machine: machine,
    job: '',
    hours: '1',
    dueDate: ''
  });
  const [mergedData, setMergedData] = useState([]);
  const [scheduleEvents, setScheduleEvents] = useState([]);
  const [allScheduleEvents, setAllScheduleEvents] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({
    job: '',
    component: '',
    date: new Date().toISOString().split('T')[0],
    time: '06:30',
    hours: '1',
    machine: 'GL540',
    fink: '',
    bink: '',
    sheetl: '',
    sheetw: '',
    method: '',
    customer: '',
    status: ''
  });
  const [isScheduleEditModalOpen, setIsScheduleEditModalOpen] = useState(false);
  const [scheduleEditFormData, setScheduleEditFormData] = useState({
    job: '',
    component: '',
    date: '',
    time: '',
    hours: '1',
    machine: 'GL540',
    fink: '',
    bink: '',
    sheetl: '',
    sheetw: '',
    method: '',
    customer: '',
    status: ''
  });



  const slotMinTime = overTimeEarly ? "05:00:00" : "06:30:00";
  const slotMaxTime = overTimeLate ? "17:00:00" : "17:30:00";

  const api = 'https://highgroundapi.herokuapp.com';
    //const api = 'http://localhost:5001';


  const getDailyAvailableHours = () => {
    const [minHours, minMinutes] = slotMinTime.split(':').map(Number);
    const [maxHours, maxMinutes] = slotMaxTime.split(':').map(Number);
    return (maxHours * 60 + maxMinutes - (minHours * 60 + minMinutes)) / 60;
  };
  const dailyAvailableHours = getDailyAvailableHours();

  const [formData, setFormData] = useState({
    start: '',
    end: '',
    machine: '',
    job: '',
    hours: '',
    dueDate: ''
  });
  const clickTimeoutRef = useRef(null);

  const config = {
    headers: {
      'Content-Type': 'application/json',
   
    }
  };

  const availableMachines = ['GL440', 'GL540', 'M110'];

  const handleDoubleClick = (item) => {
    setEditFormData({
      job: item.job || '',
      component: item.component || '',
      date: new Date().toISOString().split('T')[0],
      time: slotMinTime.slice(0, 5),
      hours: item.hours || '1',
      machine: machine || 'GL540',
      fink: item.fink || '',
      bink: item.bink || '',
      sheetl: item.sheetl || '',
      sheetw: item.sheetw || '',
      method: item.method || '',
      customer: item.customer || '',
      status: item.currentstatus || 'On Incoming'
    });
    setIsEditModalOpen(true);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const { job, component, date, time, hours, machine, fink, bink, sheetl, sheetw, method, customer, status } = editFormData;

    if (!job || !date || !time || !hours || !machine) {
      toast.error('All fields are required');
      return;
    }
    if (isNaN(hours) || parseFloat(hours) <= 0) {
      toast.error('Hours must be a positive number');
      return;
    }

    try {
      const start = new Date(`${date}T${time}:00`);
      const end = new Date(start);
      end.setHours(end.getHours() + parseFloat(hours));

      const item = sortedList.find(i => i.job === job && i.component === component) || {};
      const newEvent = {
        id: `${job}-${component || ''}-${start.toISOString()}`,
        title: `${job}${component ? ` - ${component}` : ''}`,
        start,
        end,
        extendedProps: {
          customer: customer || item.customer || null,
          currentstatus: item.currentstatus || 'On Incoming',
          status: status || item.currentstatus || 'On Incoming',
          backgroundcolor: colorchange(status || item.currentstatus || 'On Incoming'),
          hours: hours.toString(),
          dueDate: item.dueDate || null,
          component: component || null,
          _id: null,
          fink: fink || '',
          bink: bink || '',
          sheetl: sheetl || '',
          sheetw: sheetw || '',
          method: method || '',
          customer: customer || ''
        }
      };

      const newEvents = splitEventAcrossDays(newEvent);
      const dbIds = [];
      for (const event of newEvents) {
        console.log('Adding new event segment from modal:', event);
        const newDbId = await saveEvent(event);
        event.extendedProps._id = newDbId;
        dbIds.push(newDbId);
      }

      setScheduleEvents(prev => [...prev, ...newEvents]);
      toast.success('Event added to schedule');

      if (typeof fetchEvents === 'function') {
        await fetchEvents(machine);
      } else {
        await getSchedule();
      }

      setIsEditModalOpen(false);
    } catch (error) {
      console.error('Error saving event from modal:', error);
      toast.error('Failed to save event');
    }
  };



  const handleScheduleEditSubmit = async (e) => {
  e.preventDefault();
  const { job, component, date, time, hours, machine, fink, bink, cuts, customer, status } = scheduleEditFormData;
console.log(job)
console.log(date)
console.log(time)
console.log(hours)
console.log(machine)

  if (!job || !date || !time || !hours || !machine) {
    toast.error('All fields are required');
    return;
  }
  if (isNaN(hours) || parseFloat(hours) <= 0) {
    toast.error('Hours must be a positive number');
    return;
  }

  try {
    const start = new Date(`${date}T${time}:00`);
    const end = new Date(start);
    end.setHours(end.getHours() + parseFloat(hours));

    // NEW: Compute groupId by stripping the trailing segment index (e.g., '-0') from the selected event's ID
    const groupId = selectedEvent.id.replace(/-\d+$/, '');

    // Find all segments of the original event using groupId (instead of job/component)
    let relatedEvents = scheduleEvents.filter(
      evt => evt.id.replace(/-\d+$/, '') === groupId
    );
    relatedEvents.sort((a, b) => new Date(a.start) - new Date(b.start)); // Sort by start time
    if (!relatedEvents.length) {
      throw new Error('No related events found for update');
    }

    // Create the updated event object
    // CHANGED: Set id to groupId (the base without segment index)
    const updatedEvent = {
      id: groupId,
      title: customer || selectedEvent.extendedProps?.customer || 'N/A',
      start,
      end,
      extendedProps: {
        customer: customer || selectedEvent.extendedProps?.customer || null,
        currentstatus: selectedEvent.extendedProps?.currentstatus || 'On Incoming',
        status: status || selectedEvent.extendedProps?.currentstatus || 'On Incoming',
        backgroundcolor: colorchange(status || selectedEvent.extendedProps?.currentstatus || 'On Incoming'),
        hours: parseFloat(hours).toFixed(2),
        dueDate: selectedEvent.extendedProps?.dueDate || null,
        component: component || null,
        _id: relatedEvents[0].extendedProps._id || null, // Use first segment's _id
        fink: fink || selectedEvent.extendedProps?.fink || '',
        bink: bink || selectedEvent.extendedProps?.bink || '',
        cuts: cuts || selectedEvent.extendedProps?.cuts || '',
        job,
        machine
      }
    };

    // Split the updated event across days
    const updatedEvents = splitEventAcrossDays(updatedEvent);

    // Map existing _ids to new segments, preserving as many as possible
    // CHANGED: Fallback ID uses groupId (base) instead of newEvent.id
    const updatedEventsWithIds = updatedEvents.map((newEvent, index) => ({
      ...newEvent,
      id: index < relatedEvents.length ? relatedEvents[index].id : `${groupId}-${index}`,
      extendedProps: {
        ...newEvent.extendedProps,
        _id: index < relatedEvents.length ? relatedEvents[index].extendedProps._id || null : null
      }
    }));

    // Save updated segments
    const dbIds = [];
    for (const event of updatedEventsWithIds) {
      console.log('Updating event segment:', event);
      const isUpdate = !!event.extendedProps._id; // Use update endpoint if _id exists
      const newDbId = await saveEvent(event, isUpdate);
      event.extendedProps._id = newDbId;
      dbIds.push(newDbId);
    }

    // Delete extra segments if the updated event has fewer segments (e.g., hours reduced)
    if (updatedEventsWithIds.length < relatedEvents.length) {
      for (let i = updatedEventsWithIds.length; i < relatedEvents.length; i++) {
        const extraEvent = relatedEvents[i];
        if (extraEvent.extendedProps._id) {
          await axios.post(`${api}/sched/remove`, { id: extraEvent.extendedProps._id }, config);
          console.log(`Deleted extra event segment with _id: ${extraEvent.extendedProps._id}`);
        }
      }
    }

    // Update state: Replace related events with updated segments
    setScheduleEvents(prev =>
      prev
        .filter(evt => !relatedEvents.some(rel => rel.id === evt.id))
        .concat(updatedEventsWithIds)
    );
    setAllScheduleEvents(prev =>
      prev
        .filter(evt => !relatedEvents.some(rel => rel.id === evt.id))
        .concat(updatedEventsWithIds)
    );

    toast.success('Event updated in schedule');

    if (typeof fetchEvents === 'function') {
      await fetchEvents(machine);
    } else {
      await getSchedule();
    }

    setIsScheduleEditModalOpen(false);
  } catch (error) {
    console.error('Error updating event from schedule edit modal:', error);
    toast.error('Failed to update event');
  }
};


  const handleScheduleRemove = async () => {
    try {
      const event = scheduleEvents.find(evt => evt.id === selectedEvent.id);
      if (!event || !event.extendedProps._id) {
        throw new Error('Event not found or no database ID');
      }
      await axios.post(`${api}/sched/gl40/remove`, { id: event.extendedProps._id }, config);

      console.log('Event deleted from backend:', event.extendedProps._id);

      setScheduleEvents(prev => prev.filter(evt => evt.id !== selectedEvent.id));
      toast.success('Event removed from schedule');

      if (typeof fetchEvents === 'function') {
        await fetchEvents(machine);
      } else {
        await getSchedule();
      }

      setIsScheduleEditModalOpen(false);
    } catch (error) {
      console.error('Error deleting event:', error);
      toast.error('Failed to remove event');
    }
  };

  const handleScheduleDuplicate = async () => {
    try {
      const { job, component, date, time, hours, machine, fink, bink, sheetl, sheetw, method, customer, status } = scheduleEditFormData;

      if (!job || !date || !time || !hours || !machine) {
        toast.error('All fields are required');
        return;
      }
      if (isNaN(hours) || parseFloat(hours) <= 0) {
        toast.error('Hours must be a positive number');
        return;
      }

      const start = new Date(`${date}T${time}:00`);
      const end = new Date(start);
      end.setHours(end.getHours() + parseFloat(hours));

      const originalEvent = scheduleEvents.find(evt => evt.id === selectedEvent.id) || {};
      const newEventId = `${job}-${component || ''}-${start.toISOString()}-${Date.now()}`;
      const newEvent = {
        id: newEventId,
        title: `${job}${component ? ` - ${component}` : ''}`,
        start,
        end,
        extendedProps: {
          customer: customer || originalEvent.extendedProps?.customer || null,
          currentstatus: originalEvent.extendedProps?.currentstatus || 'On Incoming',
          status: status || originalEvent.extendedProps?.currentstatus || 'On Incoming',
          backgroundcolor: colorchange(status || originalEvent.extendedProps?.currentstatus || 'On Incoming'),
          hours: hours.toString(),
          dueDate: originalEvent.extendedProps?.dueDate || null,
          component: component || null,
          _id: null,
          fink: fink || originalEvent.extendedProps?.fink || '',
          bink: bink || originalEvent.extendedProps?.bink || '',
          sheetl: sheetl || originalEvent.extendedProps?.sheetl || '',
          sheetw: sheetw || originalEvent.extendedProps?.sheetw || '',
          method: method || originalEvent.extendedProps?.method || '',
          customer: customer || originalEvent.extendedProps?.customer || ''
        }
      };

      const newEvents = splitEventAcrossDays(newEvent);
      const dbIds = [];
      for (const event of newEvents) {
        console.log('Adding duplicated event segment:', event);
        const newDbId = await saveEvent(event);
        event.extendedProps._id = newDbId;
        dbIds.push(newDbId);
      }

      setScheduleEvents(prev => [...prev, ...newEvents]);
      toast.success('Event duplicated and added to schedule');

      if (typeof fetchEvents === 'function') {
        await fetchEvents(machine);
      } else {
        await getSchedule();
      }

      setIsScheduleEditModalOpen(false);
    } catch (error) {
      console.error('Error duplicating event:', error);
      toast.error('Failed to duplicate event');
    }
  };

  useEffect(() => {
    const draggableInstances = [];
    listItemsRef.current.forEach((el, index) => {
      if (el && sortedList[index]) {
        const item = sortedList[index];
        const hours = parseFloat(item.presstime1) || 1;
        const draggable = new Draggable(el, {
          eventData: {
            title: `${item.job || 'Unknown Job'}${item.component ? ` - ${item.component}` : ''}`,
            duration: `${Math.floor(hours)}:${(hours % 1 * 60).toFixed(0).padStart(2, '0')}:00`,
            extendedProps: {
              customer: item.customer || null,
              currentstatus: item.currentstatus || 'On Incoming',
              status: item.currentstatus || 'On Incoming',
              hours: item.presstime1 || '1',
              dueDate: item.dueDate || null,
              component: item.component || null,
              _id: null,
              fink: item.fink || '',
              bink: item.bink || '',
              sheetl: item.sheetl || '',
              sheetw: item.sheetw || '',
              method: item.method || '',
              customer: item.customer || ''
            }
          }
        });
        draggableInstances.push(draggable);
      }
    });

    return () => {
      draggableInstances.forEach(draggable => draggable.destroy());
    };
  }, [sortedList]);


  const getSchedule = async () => {
    try {
      const response440 = await axios.post(
        `${api}/sched/gl40/get`,
        { machine: 'GL540' },
        config
      );
      console.log('Schedule Response GL540:', response440.data);

      const response540 = await axios.post(
        `${api}/sched/gl40/get`,
        { machine: 'GL440' },
        config
      );
      console.log('Schedule Response GL440:', response540.data);

      const jobs540 = response540.data
        .filter(item => item.job)
        .map(item => item.job);
      const jobs440 = response440.data
        .filter(item => item.job)
        .map(item => item.job);
      const allJobs = [...new Set([...jobs540, ...jobs440])];

      let opsResponse = { data: [] };
      if (allJobs.length > 0) {
        opsResponse = await axios.post(
          'https://highgroundsoftware.com/dash/dashboard/php/getoperations.php',
          { jobs: allJobs },
          config
        );
        console.log('Operations Response for Schedules:', opsResponse.data);
      }



      const events540 = response540.data.map(item => {
        const matchingOperation = opsResponse.data.find(op => op.job === item.job);
        const currentstatus = item.status || 'On Incoming';
       
        return {
          id: item.id || `${item.job}-${item.component || ''}-${item.start}`,
          title: `${item.job || 'Unknown Job'}${item.component ? ` - ${item.component}` : ''}`,
          start: item.start || null,
          end: item.end || null,
          extendedProps: {
            customer: item.customer || null,
            currentstatus,
            status: currentstatus,
            backgroundcolor: colorchange(currentstatus),
            hours: item.hours || '1',
            dueDate: item.dueDate || null,
            component: item.component || null,
            _id: item._id || null,
            fink: item.fink || '',
            bink: item.bink || '',
            sheetl: item.sheetl || '',
            sheetw: item.sheetw || '',
            method: item.method || '',
            customer: item.customer || ''
          }
        };
      });

      const events440 = response440.data.map(item => {
        const matchingOperation = opsResponse.data.find(op => op.job === item.job);
        const currentstatus = item.status || 'On Incoming';
        return {
          id: item.id || `${item.job}-${item.component || ''}-${item.start}`,
          title: `${item.job || 'Unknown Job'}${item.component ? ` - ${item.component}` : ''}`,
          start: item.start || null,
          end: item.end || null,
          extendedProps: {
            customer: item.customer || null,
            currentstatus,
            status: currentstatus,
            backgroundcolor: colorchange(currentstatus),
            hours: item.hours || '1',
            dueDate: item.dueDate || null,
            component: item.component || null,
            _id: item._id || null,
            fink: item.fink || '',
            bink: item.bink || '',
            sheetl: item.sheetl || '',
            sheetw: item.sheetw || '',
            method: item.method || '',
            customer: item.customer || ''
          }
        };
      });

      console.log('Mapped Schedule Events GL540:', events540);
      console.log('Mapped Schedule Events GL540:', events440);

      setScheduleEvents(events440);
      setAllScheduleEvents([...events540, ...events440]);
    } catch (error) {
      console.error('Error fetching schedule:', error);
      toast.error('Failed to fetch schedule data');
      setScheduleEvents([]);
      setAllScheduleEvents([]);
    }
  };

  useEffect(() => {
    getSchedule();
  }, [machine]);

  const saveEvent = async (eventData, isUpdate = false) => {
    try {
      const endpoint = isUpdate && eventData.extendedProps?._id ? `${api}/sched/gl40/update` : `${api}/sched/gl40/add`;
const formatDateWithOffset = (date) => {
  if (!date) return null;
  return date.toISOString().replace('Z', '+00:00'); // Force UTC
};

      const payload = {
        dbid: eventData.extendedProps?._id || null,
        id: eventData.id || null,
        machine: eventData.extendedProps?.machine || machine || 'GL540',
        job: eventData.extendedProps?.job || eventData.title.split(' - ')[0],
        start: formatDateWithOffset(eventData.start),
        end: formatDateWithOffset(eventData.end),
        customer: eventData.extendedProps?.customer || null,
        currentstatus: eventData.extendedProps?.currentstatus || 'On Incoming',
        status: eventData.extendedProps?.status || eventData.extendedProps?.currentstatus || 'On Incoming',
        hours: eventData.extendedProps?.hours || '1',
        dueDate: eventData.extendedProps?.dueDate || null,
        component: eventData.extendedProps?.component || null,
        fink: eventData.extendedProps?.fink || '',
        bink: eventData.extendedProps?.bink || '',
        sheetl: eventData.extendedProps?.sheetl || '',
        sheetw: eventData.extendedProps?.sheetw || '',
        method: eventData.extendedProps?.method || '',
        customer: eventData.extendedProps?.customer || ''
      };
      console.log(`Sending to ${endpoint}:`, payload);
      const response = await axios.post(endpoint, payload, config);
      console.log(`Event ${isUpdate ? 'updated' : 'saved'} response:`, response.data);

      if (isUpdate && response.status === 404) {
        console.warn(`Update failed: ${response.data.message}`);
        toast.error(`Failed to update event: ${response.data.message}`);
        throw new Error(response.data.message);
      }
      if (isUpdate && response.status === 400) {
        console.warn(`Update failed: ${response.data.message}`);
        toast.error(`Failed to update event: ${response.data.message}`);
        throw new Error(response.data.message);
      }
      if (isUpdate && response.data.start && response.data.start !== payload.start) {
        console.warn(`Update may have failed: expected start ${payload.start}, got ${response.data.start}`);
        toast.warn('Event update may not have been applied');
      }
      return response.data._id || response.data.dbid;
    } catch (error) {
      console.error(`Error ${isUpdate ? 'updating' : 'saving'} event:`, error);
      toast.error(`Failed to ${isUpdate ? 'update' : 'save'} event: ${error.message}`);
      throw error;
    }
  };



const splitEventAcrossDays = (eventData) => {
  // ---- ONLY the stored hours matter ----
  const totalHours = parseFloat(eventData.extendedProps.hours) || 1;

  const [minH, minM] = slotMinTime.split(':').map(Number);
  const [maxH, maxM] = slotMaxTime.split(':').map(Number);
  const dailyAvailable = (maxH * 60 + maxM - (minH * 60 + minM)) / 60;

  const segments = [];
  let remaining = totalHours;
  let curStart = new Date(eventData.start);
  let segIdx = 0;

  while (remaining > 0) {
    // start of the working day
    const dayStart = new Date(curStart);
    dayStart.setHours(minH, minM, 0, 0);
    const dayEnd   = new Date(curStart);
    dayEnd.setHours(maxH, maxM, 0, 0);

    if (curStart < dayStart) curStart = dayStart;               // jump to day start

    const availToday = Math.max(0, (dayEnd - curStart) / 36e5);
    if (availToday <= 0) {                                     // no time left today
      curStart.setDate(curStart.getDate() + 1);
      curStart.setHours(minH, minM, 0, 0);
      continue;
    }

    const segH = Math.min(remaining, availToday);
    const segEnd = new Date(curStart);
    segEnd.setTime(segEnd.getTime() + segH * 36e5);

    segments.push({
      id: `${eventData.id}-${segIdx}`,
      title: eventData.title,
      start: new Date(curStart),
      end: segEnd,
      extendedProps: {
        ...eventData.extendedProps,
        hours: segH.toFixed(2),
        segmentIndex: segIdx,
      },
    });

    remaining -= segH;
    segIdx++;
    curStart = new Date(dayEnd);
    curStart.setDate(curStart.getDate() + 1);
    curStart.setHours(minH, minM, 0, 0);
  }
  return segments;
};

const handleEventReceive = useCallback(async (info) => {
  const draggedEl = info.draggedEl;                     // the DOM element we dragged
  const isFromSidebar = draggedEl?.classList.contains('draggable-item');

  // ---- 1. Get the *original* job data ----
  let originalCuthrs = '1';
  let job = '', component = '', customer = '', status = '',
      fink = '', bink = '', sheetl = '', sheetw = '', method = '', dueDate = '';

  if (isFromSidebar) {
    // find the index inside the list container
    const listContainer = draggedEl.parentNode;
    const index = Array.from(listContainer.children).indexOf(draggedEl);
    const item = sortedList[index];
 
    if (item) {
      console.log('from list')
      originalCuthrs = item.presstime1 || '1';
      job        = item.job || '';
      component  = item.component || '';
      customer   = item.customer || '';
      status     = item.currentstatus || 'On Incoming';
      fink       = item.fink || '';
      bink       = item.bink || '';
      sheetl     = item.sheetl || '';
      sheetw     = item.sheetw || '';
      method     = item.method || '';
      dueDate    = item.dueDate || null;
    }
  } else {
    console.log('from cal')
   
  }
  
  const groupId = `${job}-${component || ''}`;
  const existing = scheduleEvents.find(e => e.id.replace(/-\d+$/, '') === groupId);

  // ---- 2. Build the *base* event (dummy end) ----
  const baseEvent = {
    id: groupId,
    title: `${job}${component ? ` - ${component}` : ''}`,
    start: info.event.start,
    end: info.event.start,                     // dummy – split uses hours
    extendedProps: {
      customer,
      currentstatus: status,
      status,
      backgroundcolor: colorchange(status),
      hours: originalCuthrs,                 // <-- the important line
      dueDate,
      component,
      _id: existing?.extendedProps._id || null,
      fink, bink, sheetl, sheetw, method,
      job,
      machine: machine || 'GL540',
    },
  };

  // ---- 3. Split & assign segment IDs ----
  let newSegments = splitEventAcrossDays(baseEvent).map((seg, i) => ({
    ...seg,
    id: `${groupId}-${i}`,
  }));

  try {
    // ---- 4. Persist every segment ----
    for (const seg of newSegments) {
      const dbId = await saveEvent(seg, !!seg.extendedProps._id);
      seg.extendedProps._id = dbId;
    }

    // ---- 5. Replace the old group with the new segments ----
    setScheduleEvents(prev => [
      ...prev.filter(e => e.id.replace(/-\d+$/, '') !== groupId),
      ...newSegments,
    ]);

    toast.success(existing ? 'Event moved' : 'Event added');

    if (typeof fetchEvents === 'function') await fetchEvents(machine);
    else await getSchedule();
  } catch (err) {
    console.error('handleEventReceive error:', err);
    toast.error('Failed to save event');
  }
}, [sortedList, scheduleEvents, machine, fetchEvents]);



const handleEventDrop = useCallback(async (info) => {
  const groupId = info.event.id.replace(/-\d+$/, '');
  const originalCuthrs = info.event.extendedProps.hours || '1';
console.log(info.event.extendedProps)
  const baseEvent = {
    id: groupId,
    title: info.event.title,
    start: info.event.start,
    end: info.event.start,               // dummy
    extendedProps: {
      ...info.event.extendedProps,
      hours: originalCuthrs,           // <-- keep original hours
      machine: machine || 'GL540',
    },
  };

  const updatedSegments = splitEventAcrossDays(baseEvent).map((seg, i) => ({
    ...seg,
    id: `${groupId}-${i}`,
  }));

  try {
    for (const seg of updatedSegments) {
      const dbId = await saveEvent(seg, !!seg.extendedProps._id);
      seg.extendedProps._id = dbId;
    }

    setScheduleEvents(prev => [
      ...prev.filter(e => e.id.replace(/-\d+$/, '') !== groupId),
      ...updatedSegments,
    ]);

    if (typeof fetchEvents === 'function') await fetchEvents(machine);
    else await getSchedule();

    toast.success('Event moved');
  } catch (err) {
    console.error('handleEventDrop error:', err);
    toast.error('Failed to move event');
  }
}, [machine, fetchEvents]);




  const handleEventClick = useCallback((info) => {
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
      clickTimeoutRef.current = null;
      const job = info.event.title.split(' - ')[0];
      const component = info.event.extendedProps.component || '';
      setScheduleEditFormData({
        job,
        component,
        date: info.event.start.toISOString().split('T')[0],
        time: info.event.start.toTimeString().slice(0, 5),
        hours: info.event.extendedProps.hours || '1',
        machine: machine || 'GL540',
        fink: info.event.extendedProps.fink || '',
        bink: info.event.extendedProps.bink || '',
        hours:info.event.extendedProps.hours || 1,
        sheetl: info.event.extendedProps.sheetl || '',
        sheetw: info.event.extendedProps.sheetw || '',
        method: info.event.extendedProps.method || '',
        customer: info.event.extendedProps.customer || '',
        status: info.event.extendedProps.status || info.event.extendedProps.currentstatus || 'On Incoming'
      });
      setSelectedEvent({
        id: info.event.id,
        title: info.event.title,
        start: info.event.start,
        end: info.event.end,
        extendedProps: info.event.extendedProps
      });
      setIsScheduleEditModalOpen(true);
    } else {
      clickTimeoutRef.current = setTimeout(() => {
        console.log('Event clicked:', info.event.toPlainObject());
        setSelectedEvent({
          id: info.event.id,
          title: info.event.title,
          start: info.event.start,
          end: info.event.end,
          extendedProps: info.event.extendedProps
        });
        clickTimeoutRef.current = null;
      }, 300);
    }
  }, []);

  useEffect(() => {
    const getactive = async () => {
      try {
        const activeResponse = await axios.post(
          'https://highgroundsoftware.com/dash/dashboard/php/getactivejobs.php',
          { job: '123456' },
          config
        );
        console.log('Active Jobs Response:', activeResponse.data);

        const jobIds = activeResponse.data.map(item => item.quote);

        const impoResponse4 = await axios.post(
          'https://highgroundsoftware.com/dash/dashboard/php/getImpo.php',
          { jobs: jobIds, press: 3 },
          config
        );
        console.log('Impo Response (press=3):', impoResponse4.data);

        const impoResponse3 = await axios.post(
          'https://highgroundsoftware.com/dash/dashboard/php/getImpo.php',
          { jobs: jobIds, press: 4 },
          config
        );
        console.log('Impo Response (press=4):', impoResponse3.data);

        const combinedImpoData = [
          ...impoResponse4.data,
          ...impoResponse3.data.filter(
            item3 => !impoResponse4.data.some(item4 => item4.quote === item3.quote && item4.component === item3.component)
          )
        ];

        let mergedData = combinedImpoData.map(impo => {
          const matchingActiveJob = activeResponse.data.find(active => active.quote === impo.quote);
          return {
            ...impo,
            customer: matchingActiveJob ? matchingActiveJob.customer : null,
            job: matchingActiveJob ? matchingActiveJob.job : null,
            status: matchingActiveJob ? matchingActiveJob.status || 'On Incoming' : 'On Incoming'
          };
        });

        console.log('Merged Data (Initial):', mergedData);
        setMergedData(mergedData);

        const jobsFromMerged = mergedData
          .filter(item => item.job !== null)
          .map(item => item.job);
        console.log('Jobs from Merged Data:', jobsFromMerged);

        const opsResponse = await axios.post(
          'https://highgroundsoftware.com/dash/dashboard/php/getoperations.php',
          { jobs: jobsFromMerged },
          config
        );
        console.log('Operations Response:', opsResponse.data);

        mergedData = mergedData.map(impo => {
          const matchingOperation = opsResponse.data.find(op => op.job === impo.job);
          return {
            ...impo,
            currentstatus: matchingOperation ? matchingOperation.name : 'On Incoming',
            status: matchingOperation ? matchingOperation.name : 'On Incoming'
          };
        });

        setMergedData(mergedData);
      } catch (error) {
        console.error('Error fetching data:', error);
        toast.error('Failed to fetch data from the server');
      }
    };

    getactive();
  }, [machine]);



  useEffect(() => {
    console.log('Sorting list, checking dueDate values:');
    const sourceList = mergedData.length > 0 ? mergedData : (list || []);
    sourceList?.forEach((item, index) => {
      // Add any necessary logging or checks here
    });
    let sorted = [...sourceList].sort((a, b) => {
      if (sortOption === 'dueDate') {
        const dateA = a.dueDate ? new Date(a.dueDate) : new Date(0);
        const dateB = b.dueDate ? new Date(b.dueDate) : new Date(0);
        return dateA - dateB;
      } else if (sortOption === 'job') {
        const jobA = a.job || '';
        const jobB = b.job || '';
        return jobA.localeCompare(jobB);
      } else if (sortOption === 'status') {
        const statusA = a.currentstatus || a.status || '';
        const statusB = b.currentstatus || b.status || '';
        return statusA.localeCompare(statusB);
      } else if (sortOption === 'customer') {
        const customerA = a.customer || '';
        const customerB = b.customer || '';
        return customerA.localeCompare(customerB);
      }
      return 0;
    });
    const filtered = sorted.filter(item =>
      !allScheduleEvents.some(evt => evt.title.split(' - ')[0] === item.job && evt.extendedProps.component === item.component)
    );
    setSortedList(filtered);
  }, [list, mergedData, sortOption, allScheduleEvents]);

  const renderEventContent = (eventInfo) => {
    const { event } = eventInfo;
    const { extendedProps } = event;
    const hours = extendedProps.hours && !isNaN(parseFloat(extendedProps.hours))
      ? Number(extendedProps.hours).toFixed(2)
      : ((event.end - event.start) / (1000 * 60 * 60)).toFixed(2) || '1.00';
    return (
      <div
        className="p-2 bg-gray-200 border-1 py-3"
        style={{
          background: colorchange(extendedProps.status || extendedProps.currentstatus || 'On Incoming'),
          fontSize: 'calc(1rem + .1vw)',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        <strong style={{ fontSize: 'calc(.9rem + .1vw)', overflow: 'elip' }}>
          {extendedProps.customer || 'N/A'}
        </strong>
        <br />
        Status: {extendedProps.status || extendedProps.currentstatus || 'On Incoming'}
        <br />
        Job: {event.title || 'N/A'}
        <br />
        Hours: {hours}
        <br />
        Inks: {extendedProps.fink || 'N/A'} {extendedProps.bink ? ` / ${extendedProps.bink}` : ' / 0'}
        <br />
        {extendedProps.sheetl && extendedProps.sheetw ? `${extendedProps.sheetl} X ${extendedProps.sheetw}` : 'N/A'}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{extendedProps.method || 'N/A'}
      </div>
    );
  };

  return (
    <div>
      <style>
        {`
          .draggable-item {
            font-size: 0.9rem;
            line-height: 1.2;
            overflow: hidden;
            cursor: move;
            user-select: none;
          }
          .fc-draggable.dragging, .draggable-item.dragging {
            font-size: 0.9rem !important;
            line-height: 1.2 !important;
            overflow: hidden !important;
            opacity: 0.8 !important;
          }
          .modal {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: white;
            padding: 20px;
            border-radius: 5px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.2);
            z-index: 1000;
          }
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.5);
            z-index: 999;
          }
          .modal form {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .modal label {
            font-weight: bold;
          }
          .modal input, .modal select {
            padding: 5px;
            border: 1px solid #ccc;
            border-radius: 3px;
          }
          .modal button {
            margin-top: 10px;
            padding: 5px 10px;
            border: none;
            border-radius: 3px;
            cursor: pointer;
          }
          .modal button[type="submit"] {
            background: #28a745;
            color: white;
          }
          .modal button[type="button"] {
            background: #dc3545;
            color: white;
          }
          .modal button.duplicate {
            background: #007bff;
            color: white;
          }
        `}
      </style>
      <div className='flex'>
        <div className='flex-[.3]' style={{ marginBottom: '10px' }}>
          <div className='flex'>
            <div className='flex-1' style={{ marginBottom: '10px' }}>
              <label htmlFor="sortOption">Sort by: </label>
              <select
                id="sortOption"
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value)}
                style={{ padding: '0px', marginLeft: '5px' }}
              >
                <option value="job">Default</option>
                <option value="dueDate">Due Date</option>
                <option value="job">Job</option>
                <option value="status">Status</option>
                <option value="customer">Customer</option>
              </select>
            </div>
            <div className='flex-1 flex items-center justify-center'>
              {sortedList?.length} Jobs
            </div>
          </div>
          <Scroll minHeight="20px" maxHeight="55vh">
            {sortedList?.length > 0 ? (
              sortedList?.map((item, index) => (
                <div
                  key={item.uuid || `${item.job || 'unknown'}-${item.component || 'unknown'}-${index}`}
                  ref={(el) => (listItemsRef.current[index] = el)}
                  className="draggable-item p-2 m-1 bg-gray-200 cursor-move border-1 py-3"
                  style={{ borderBottom: '15px', padding: '5px', background: colorchange(item.currentstatus) }}
                  onDoubleClick={() => handleDoubleClick(item)}
                >
                  <div style={{ fontSize: 'calc(1rem + .1vw)' }}>
                    <strong style={{ fontSize: 'calc(1.1rem + .1vw)' }}>{item.customer || 'N/A'}</strong><br />
                    Status: {item.status || item.currentstatus || 'On Incoming'}<br />
                    Job: {item.job || 'N/A'} - {item.component || 'N/A'}<br />
                    Hours: {Number(item.presstime1).toFixed(2) || 'N/A'}<br />
                    Inks: {item.fink} {item.bink > "" ? ` / ${item.bink}` : ` / 0`}<br />
                    {item.faq > "" ? `Aq: ${item.faq}` : null} {item.baq > "" ? <> / {item.baq}<br /></> : null}
                    {item.sheetl} X {item.sheetw}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.method}<br />
                    Status: {item.currentstatus || 'On Incoming'}
                  </div>
                </div>
              ))
            ) : (
              <div>No jobs available</div>
            )}
          </Scroll>
        </div>
        <div className='flex-1' style={{ padding: "0px 10px 0px 10px", position: 'relative', color: 'black' }}>
          <div style={{ marginBottom: '10px', position: "absolute", top: '14px', left: '20vw', zIndex: '200' }}>
            {/* <Button onClick={handleAddModalOpen}>Add New Job</Button> */}
          </div>
          <h2>{machine} Schedule</h2>
          <FullCalendar
            ref={calendarRef}
            hiddenDays={[0]}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="timeGridWeek"
            events={scheduleEvents}
            editable={true}
            droppable={true}
            eventReceive={handleEventReceive}
            eventDrop={handleEventDrop}
            eventClick={handleEventClick}
            headerToolbar={{
              left: 'title',
              center: '',
              right: 'prev,next today dayGridMonth,timeGridWeek,timeGridDay'
            }}
            slotMinTime={slotMinTime}
            slotMaxTime={slotMaxTime}
            allDaySlot={false}
            slotDuration="00:30:00"
            slotLabelInterval="0:30:00"
            height='60vh'
            eventConstraint={{ startTime: '00:00:00', endTime: '23:59:59' }}
            eventTextColor='black'
            eventContent={renderEventContent}
            eventDidMount={(info) => {
              const status = info.event.extendedProps.status || info.event.extendedProps.currentstatus || 'On Incoming';
              const color = colorchange(status);
              info.el.style.backgroundColor = color;
              info.el.style.borderColor = color;
              info.el.style.setProperty('textColor', 'black', 'important');
              info.el.title = `${info.event.title}\nCustomer: ${info.event.extendedProps.customer || 'N/A'}\nStatus: ${info.event.extendedProps.status || info.event.extendedProps.currentstatus || 'On Incoming'}\nInks: ${info.event.extendedProps.fink || 'N/A'} / ${info.event.extendedProps.bink || 'N/A'}\nSheet: ${info.event.extendedProps.sheetl || 'N/A'} x ${info.event.extendedProps.sheetw || 'N/A'}\nMethod: ${info.event.extendedProps.method || 'N/A'}`;
            }}
          />
        </div>
      </div>

      <div className='' style={{ marginTop: '30px' }}>
        <div className='flex space-x-4'>
          <div className='flex items-center' style={{ marginRight: '30px', fontWeight: "bold", fontSize: 'calc(1.2rem + .2vw)', minWidth: '100px', padding: '6px 0px' }}>Prepress</div>
          <div className='flex items-center' style={{ marginRight: '30px', fontSize: 'calc(1.2rem + .2vw)' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#00FF00', marginRight: '8px' }}></div>
            Ready Plating
          </div>
          <div className='flex items-center' style={{ marginRight: '30px', fontSize: 'calc(1.2rem + .2vw)' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: 'rgb(0, 128, 128,1)', marginRight: '8px' }}></div>
            On Prepress
          </div>
          <div className='flex items-center' style={{ marginRight: '30px', fontSize: 'calc(1.2rem + .2vw)' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: 'rgb(192, 64, 0,.9)', marginRight: '8px' }}></div>
            Off Prepress
          </div>
        </div>

        <div className='flex space-x-4'>
          <div className='flex items-center' style={{ marginRight: '30px', fontWeight: "bold", fontSize: 'calc(1.2rem + .2vw)', minWidth: '100px', padding: '6px 0px' }}>Press</div>
          <div className='flex items-center' style={{ marginRight: '30px', fontSize: 'calc(1.2rem + .2vw)' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#79BB43', marginRight: '8px' }}></div>
            Ready Press
          </div>
          <div className='flex items-center' style={{ marginRight: '30px', fontSize: 'calc(1.2rem + .2vw)' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#f5f513ff', marginRight: '8px' }}></div>
            On Press
          </div>
          <div className='flex items-center' style={{ marginRight: '30px', fontSize: 'calc(1.2rem + .2vw)' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: 'rgb(237,125,49,.9)', marginRight: '8px' }}></div>
            Off Press
          </div>
          <div className='flex items-center' style={{ marginRight: '30px', fontSize: 'calc(1.2rem + .2vw)' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: 'rgb(255,0,0,.3)', marginRight: '8px' }}></div>
            Incomplete Press
          </div>
        </div>

        <div className='flex space-x-4'>
          <div className='flex items-center' style={{ marginRight: '30px', fontWeight: "bold", fontSize: 'calc(1.2rem + .2vw)', minWidth: '100px', padding: '6px 0px' }}>Bindery</div>
          <div className='flex items-center' style={{ marginRight: '30px', fontSize: 'calc(1.2rem + .2vw)' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: 'rgb(100, 149, 237,1)', marginRight: '8px' }}></div>
            On Bindery
          </div>
          <div className='flex items-center' style={{ marginRight: '30px', fontSize: 'calc(1.2rem + .2vw)' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: 'rgb(250, 95, 85,.8)', marginRight: '8px' }}></div>
            Off Bindery
          </div>
          <div className='flex items-center' style={{ marginRight: '30px', fontSize: 'calc(1.2rem + .2vw)' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: 'orchid', marginRight: '8px' }}></div>
            Incomplete Bindery
          </div>
        </div>
      </div>

      {isEditModalOpen && (
        <>
          <div className="modal-overlay" onClick={() => setIsEditModalOpen(false)}></div>
          <div className="modal">
            <h3>Schedule Job: {editFormData.job}{editFormData.component ? ` - ${editFormData.component}` : ''}</h3>
            <form onSubmit={handleEditSubmit}>
              <label>
                Date:
                <input
                  type="date"
                  value={editFormData.date}
                  onChange={(e) => setEditFormData({ ...editFormData, date: e.target.value })}
                  required
                />
              </label>
              <label>
                Time:
                <input
                  type="time"
                  value={editFormData.time}
                  onChange={(e) => setEditFormData({ ...editFormData, time: e.target.value })}
                  step="1800"
                  required
                />
              </label>
              <label>
                Hours:
                <input
                  type="number"
                  value={editFormData.hours}
                  onChange={(e) => setEditFormData({ ...editFormData, hours: e.target.value })}
                  min="0.01"
                  step="0.01"
                  required
                />
              </label>
              <label>
                Press:
                <select
                  value={editFormData.machine}
                  onChange={(e) => setEditFormData({ ...editFormData, machine: e.target.value })}
                  required
                >
                  {availableMachines.map(m => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </select>
              </label>
              <label>
                Front Inks:
                <input
                  type="text"
                  value={editFormData.fink}
                  onChange={(e) => setEditFormData({ ...editFormData, fink: e.target.value })}
                />
              </label>
              <label>
                Back Inks:
                <input
                  type="text"
                  value={editFormData.bink}
                  onChange={(e) => setEditFormData({ ...editFormData, bink: e.target.value })}
                />
              </label>
              <label>
                Sheet Length:
                <input
                  type="text"
                  value={editFormData.sheetl}
                  onChange={(e) => setEditFormData({ ...editFormData, sheetl: e.target.value })}
                />
              </label>
              <label>
                Sheet Width:
                <input
                  type="text"
                  value={editFormData.sheetw}
                  onChange={(e) => setEditFormData({ ...editFormData, sheetw: e.target.value })}
                />
              </label>
              <label>
                Method:
                <input
                  type="text"
                  value={editFormData.method}
                  onChange={(e) => setEditFormData({ ...editFormData, method: e.target.value })}
                />
              </label>
              <label>
                Customer:
                <input
                  type="text"
                  value={editFormData.customer}
                  onChange={(e) => setEditFormData({ ...editFormData, customer: e.target.value })}
                />
              </label>
              <label>
                Status:
                <input
                  type="text"
                  value={editFormData.status}
                  onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })}
                />
              </label>
              <button type="submit">Save</button>
              <button type="button" onClick={() => setIsEditModalOpen(false)}>Cancel</button>
            </form>
          </div>
        </>
      )}
      {isScheduleEditModalOpen && (
        <>
          <div className="modal-overlay" onClick={() => setIsScheduleEditModalOpen(false)}></div>
          <div className="modal">
            <h3>Edit Scheduled Event: {scheduleEditFormData.job}{scheduleEditFormData.component ? ` - ${scheduleEditFormData.component}` : ''}</h3>
            <form onSubmit={handleScheduleEditSubmit}>
              <label>
                Date:
                <input
                  type="date"
                  value={scheduleEditFormData.date}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, date: e.target.value })}
                  required
                />
              </label>
              <label>
                Time:
                <input
                  type="time"
                  value={scheduleEditFormData.time}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, time: e.target.value })}
                  step="1800"
                  required
                />
              </label>
              <label>
                Hours:
                <input
                  type="number"
                  value={scheduleEditFormData.hours}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, hours: e.target.value })}
                  min="0.01"
                  step="0.01"
                  required
                />
              </label>
              <label>
                Press:
                <select
                  value={scheduleEditFormData.machine}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, machine: e.target.value })}
                  required
                >
                  {availableMachines.map(m => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </select>
              </label>
              <label>
                Front Inks:
                <input
                  type="text"
                  value={scheduleEditFormData.fink}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, fink: e.target.value })}
                />
              </label>
              <label>
                Back Inks:
                <input
                  type="text"
                  value={scheduleEditFormData.bink}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, bink: e.target.value })}
                />
              </label>
              <label>
                Sheet Length:
                <input
                  type="text"
                  value={scheduleEditFormData.sheetl}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, sheetl: e.target.value })}
                />
              </label>
              <label>
                Sheet Width:
                <input
                  type="text"
                  value={scheduleEditFormData.sheetw}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, sheetw: e.target.value })}
                />
              </label>
              <label>
                Method:
                <input
                  type="text"
                  value={scheduleEditFormData.method}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, method: e.target.value })}
                />
              </label>
              <label>
                Customer:
                <input
                  type="text"
                  value={scheduleEditFormData.customer}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, customer: e.target.value })}
                />
              </label>
              <label>
                Status:
                 <select  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, status: e.target.value })}>
                   <optgroup label="Prepress">
                  <option value='Ready Prepress'>Ready Prepress</option>
                  <option value='On Prepressss'>On PrePrepressss</option>
                  <option value='Off Prepress'>Off Prepress</option>
                   <option value='Ready Plating'>Ready Plating</option>
                   </optgroup>
                  <optgroup label="Press">
                  <option value='Ready Press'>Ready Press</option>
                  <option value='Ready Press'>On Press</option>
                  <option value='Ready Press'>Off Press</option>
                   <option value='Ready Press'>Ready Bindery</option>
                   </optgroup>
                </select>
            
              </label>
              <button type="submit">Save</button>
              <button type="button" className="duplicate" onClick={handleScheduleDuplicate}>Duplicate</button>
              <button type="button" onClick={handleScheduleRemove}>Remove</button>
              <button type="button" onClick={() => setIsScheduleEditModalOpen(false)}>Cancel</button>
            </form>
          </div>
        </>
      )}
    </div>
  );
};

export default GL540;










